var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls,style:({height: 'auto'})},[_c('el-carousel',{staticClass:"my-carousel",attrs:{"height":`${_vm.height}px`,"autoplay":false}},_vm._l((_vm.carouselData),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{style:({ height: `${_vm.height}px` }),attrs:{"src":item.pic,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }